
// phone-modal.component.ts
import { Component } from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';

@Component({
  selector: 'app-phone-modal',
  templateUrl: './phone-modal.component.html',
  standalone: true,
  styleUrl: './phone-modal.component.scss'

})
export class PhoneModalComponent {
  constructor(private router: Router,private modalService: NgbModal,public activeModal: NgbActiveModal) {}

  redirectToPhonePage() {
    this.router.navigate(['/secu','compte']);

    // Redirection logic
    this.activeModal.close('redirect');
  }

  // redirectToPhonePage2() {
  //   this.router.navigate(['/profil','compte']);
  //   this.modalService.dismissAll();
  // }
}